import { createSelector } from '@ngrx/store';
import { orderEntityAdapter as EntityAdapter, OrderState as EntityState } from './order.state';
import { Order as Entity } from './order.model';
import { AppState } from '../app-store.state';

export const selectState = (state: AppState) => state.order;

export const selectAll = createSelector(selectState, EntityAdapter.getSelectors().selectAll);

export const selectById = (entityId: number) =>
    createSelector(selectAll, (entities: Entity[]) => entities.find(e => e.id === entityId));

export const isLoading = createSelector(selectState, (state: EntityState) => state.isLoading);

export const hasErrors = createSelector(selectState, (state: EntityState) => state.error);

export const findByCorrelationId = <T>(correlationId: string) =>
    createSelector(
        selectState,
        (state: EntityState) => <T>state.history.find(h => h.correlationId === correlationId)?.payload
    );

export const currentEntity = createSelector(selectState, (state: EntityState) => {
    return state.currentEntityId ? state.entities[state.currentEntityId] : undefined;
});

export const totalPageable = createSelector(selectState, (state: EntityState) => state.currentPage.totalCount);
export const currentPage = createSelector(selectState, (state: EntityState) => state.currentPage.page);

export const OrderSelectors = {
    selectAll,
    selectById,
    isLoading,
    hasErrors,
    findByCorrelationId,
    currentEntity,
    totalPageable,
    currentPage,
};
